export default __webpack_public_path__ + "static/media/vf-resolved.c5196fa4.svg";